import axios from 'axios';
import { BaseHttpClient } from '../BaseHttpClient';
import { injectCommonInterceptors } from '../interceptors';
import { AnalyticsPayload, BatchMetricsResponse } from './api.schema';
import { BASE_URL } from './consts';

const axiosInsightsInstance = axios.create({
  baseURL: BASE_URL,
});

injectCommonInterceptors(axiosInsightsInstance);
export class InsightsClient extends BaseHttpClient {
  constructor() {
    super(axiosInsightsInstance);
  }

  // Singleton instance for access without instantiation
  static override instance = new InsightsClient();

  static async getBatchMetrics(
    payload: AnalyticsPayload,
  ): Promise<BatchMetricsResponse> {
    return await InsightsClient.post<BatchMetricsResponse>(
      '/api/analytics/batch',
      payload,
      {
        timeout: 5000,
      },
    );
  }
}
